const OpenaiModel = {
    GPT3_5: "text-davinci-002-render-sha",
    GPT4_Mobile: "gpt-4-mobile",
    GPT4: "gpt-4",
};
export default OpenaiModel;